import { Injectable } from '@angular/core';

interface Cookie {
    name: string;
    value: string;
}

@Injectable()
export class CookieService {
    private _cookies: Cookie[];

    create(name: string, value: string, expiry: Date): void {
        document.cookie = `${name}=${value}; path=/; expires=${expiry.toUTCString()}; samesite=lax; secure`;
    }

    get(name: string): any {
        this._load();
        for (let i = 0; i < this._cookies.length; i++) {
            const c = this._cookies[i];
            if (c.name === name) {
                return c;
            }
        }
        return null;
    }

    getAll(): Cookie[] {
        this._load();
        return this._cookies;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    destroy(name: string) {
        this._load();
        for (let i = 0; i < this._cookies.length; i++) {
            const c = this._cookies[i];
            if (c.name === name) {
                document.cookie = `${c.name}=${
                    c.value
                }; path=/; expires=${new Date(0).toUTCString()}`;
            }
        }
    }

    // TODO remove
    log(): void {
        this._load();
    }

    private _load(): void {
        this._cookies = [];

        document.cookie.split(/[;,]/).forEach((value) => {
            const parts = value.split(/=/, 2);
            if (parts.length !== 2) return;
            const n = decodeURIComponent(parts[0]).trim();
            const v = decodeURIComponent(parts[1]).trim();
            this._cookies.push({ name: n, value: v });
        });

        console.log(this._cookies);
    }
}
